import useResponsive from "hooks/useResponsive";
import { useEffect, useState } from "react";
import useDomain from "hooks/useDomain";

import { useConfigPromp } from "routes/context";
import { Statuses } from "utils/InterfaceAndTypeGeneral";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/routes";
import useInteractionTracker from "hooks/useInteractionTracker";

const useDelivery = () => {
  const navigate = useNavigate();
  const { setBlocking, setHeader } = useConfigPromp();
  const { isMinorTablet } = useResponsive();
  const { markInteractionStart,markInteractionEnd } = useInteractionTracker();
  const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);
  const {
    run: runSummary,
    data: dataSummary,
    isError: isErrorSummary,
    isLoading: isLoadingSummary,
  } = useDomain();

  const handleGetSummary = async () => {
    markInteractionStart("FROM_DELIVERY_EXAM", "Vista entrega examen");
    const { data } = await runSummary((domain: any) =>
      domain.get_summary_use_case.execute()
    );
    markInteractionEnd("FROM_DELIVERY_EXAM", "Vista entrega examen");
    if (data?.status === Statuses.NOT_DELIVERED || data?.status === Statuses.SCHEDULED) {
      navigate(ROUTES.candidate.summary);
    }
    setIsFirstLoading(false);
  };

  useEffect(() => {
    handleGetSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setHeader(true);
    setBlocking(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isMinorTablet,
    isError: isErrorSummary,
    isLoading: isFirstLoading || isLoadingSummary,
    titleSummary: dataSummary?.title,
    statusSummary: dataSummary?.status,
    isOutOfData: dataSummary?.status === Statuses.OUT_OF_DATE,
  };
};

export default useDelivery;
